const React = require('react');
const {paramStore} = require('../../../../../../stores');
const withState = require('../../../../../../utils/withState');

const paymentId$ = paramStore('paymentId', '');

module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    return () => {
      paymentId$.emit('');
    }
  })
  return (state, props) => {
    const views = props.views;
    const View = views[state.paymentId ? 'details' : 'table'];

    return (
      <View emitter={paymentId$} />
    )
  }
}, {
  paymentId: paymentId$
})
